// Neon Chips — client-side game currency.
// Earned per run (score/10 by default), spent on consumables.
// Synced to the server via /api/player/sync (neon_chips field).
const CHIPS_KEY = "ppe_neon_chips_v1";
const FREEZE_KEY = "ppe_streak_freezes_v1";

export function getChips() {
  return Number(localStorage.getItem(CHIPS_KEY) || 0) || 0;
}

export function setChips(n) {
  localStorage.setItem(CHIPS_KEY, String(Math.max(0, Math.floor(n))));
}

export function addChips(delta) {
  const next = Math.max(0, getChips() + Math.floor(delta || 0));
  setChips(next);
  return next;
}

export function spendChips(cost) {
  const have = getChips();
  if (have < cost) return { ok: false, have };
  setChips(have - cost);
  return { ok: true, have: have - cost };
}

/** Award chips for a completed run based on score. */
export function awardChipsForRun({ score = 0, won = false, beatBoss = false, wagerMult = 1, rouletteMult = 1 } = {}) {
  const base = Math.floor(score / 10);       // 1 chip per 10 points
  const bonus = won ? 25 : 0;                // win bonus
  const bossMult = beatBoss && won ? 3 : 1;  // beach boss buggy survival = 3× total payout
  const rMult = won ? Math.max(1, rouletteMult) : 1;
  const total = Math.floor((base + bonus) * bossMult * (won ? wagerMult : 1) * rMult);
  return addChips(total);
}

// Streak-freeze tokens ---------------------------------------------------------
export function getFreezes() {
  return Number(localStorage.getItem(FREEZE_KEY) || 0) || 0;
}
export function setFreezes(n) {
  localStorage.setItem(FREEZE_KEY, String(Math.max(0, Math.floor(n))));
}
export function consumeFreeze() {
  const have = getFreezes();
  if (have <= 0) return false;
  setFreezes(have - 1);
  return true;
}

// SHOP CATALOG — all prices in chips
export const SHOP_ITEMS = [
  { id: "freeze",    label: "Streak Freeze",  desc: "Auto-heal the next broken streak", price: 200, kind: "freeze" },
  { id: "chips_50",  label: "50 Chips Boost", desc: "Instant top-up (test/thank-you)",  price: 0,   kind: "grant", amount: 50, oneShot: true },
];
